module.exports = __webpack_public_path__ + "img/gradient.caafa176.png";